import { IncomingMessage } from 'http';
import { NextRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';

import { DEFAULT_PAGE_SIZE } from 'consts';
import { getCookie, parseCookie } from 'utils/cookie';

const PAGE_PARAM = 'page';
const PAGE_SIZE_COOKIE = 'page_size';

export function parsePagination(query: ParsedUrlQuery, req?: IncomingMessage) {
  const page = parseInt(query[PAGE_PARAM]?.toString() || '') || 1;
  const cookie =
    parseCookie(req?.headers.cookie || '', PAGE_SIZE_COOKIE) || getCookie(PAGE_SIZE_COOKIE) || '';
  const pageSize = parseInt(cookie) || DEFAULT_PAGE_SIZE;

  return {
    page,
    pageSize,
  };
}

export function setPageSize(router: NextRouter, pageSize: number) {
  document.cookie = `${PAGE_SIZE_COOKIE}=${pageSize}; path=/; SameSite=Lax; Max-Age=${
    86400 * 3650
  }`;

  router.push({
    pathname: router.pathname,
    query: {
      ...router.query,
      [PAGE_PARAM]: 1,
    },
  });
}
